import { MONTH_KEY, MONTHS, TODAY } from "@/data/mock";

const sum = (arr) => arr.reduce((a, e) => a + Number(e.value), 0);
export const inMonth = (e) => e.date.startsWith(MONTH_KEY);
export const pct = (v, goal) => (goal ? Math.round((v / goal) * 100) : 0);
export const rate = (items) => (items.length ? Math.round((items.filter((i) => i.done).length / items.length) * 100) : 0);

export const teamOf = (s, cid) => s.collaborators.filter((c) => c.companyId === cid);
export const monthSales = (s, cid) => s.sales.filter((e) => e.companyId === cid && inMonth(e));
export const companySales = (s, cid) => sum(monthSales(s, cid));
export const collabSales = (s, id) => sum(s.sales.filter((e) => e.collaboratorId === id && inMonth(e)));
export const nameMap = (s) => Object.fromEntries(s.collaborators.map((c) => [c.id, c.name]));

export const visibleTasks = (s, c) =>
  s.tasks.filter((t) => t.companyId === c.companyId && (t.collaboratorId === c.id || (!t.collaboratorId && (t.teamRole === "*" || t.teamRole === c.role))));

export const ranking = (s, cid) => {
  const rows = teamOf(s, cid)
    .map((c) => {
      const sales = collabSales(s, c.id);
      const att = pct(sales, c.goal);
      const tasks = rate(visibleTasks(s, c));
      return { ...c, sales, att, tasks, score: Math.round(Math.min(att, 120) * 0.7 + tasks * 0.3) };
    })
    .sort((a, b) => b.score - a.score)
    .map((r, i) => ({ ...r, position: i + 1 }));
  if (!s.serverRanking) return rows;
  const mine = Object.fromEntries(rows.map((r) => [r.id, r]));
  return s.serverRanking.filter((r) => r.companyId === cid).map((r) => (r.score === undefined ? r : { ...mine[r.id], position: r.position }));
};

export const companyHistory = (s, company) =>
  MONTHS.map((mes, i) => ({ mes, vendas: i < MONTHS.length - 1 ? company.history[i] : companySales(s, company.id), meta: company.salesGoal }));

export const companySummary = (s, company) => {
  const sales = companySales(s, company.id);
  return {
    ...company,
    sales,
    att: pct(sales, company.salesGoal),
    team: teamOf(s, company.id).length,
    taskRate: rate(s.tasks.filter((t) => t.companyId === company.id)),
    trainingAvg: trainingAvg(s, teamOf(s, company.id).map((c) => c.id)),
    overdue: s.tasks.filter((t) => t.companyId === company.id && (t.status === "pendente" || t.status === "andamento") && t.dueDate < TODAY).length,
  };
};

export const pendingProofs = (s, cid) =>
  s.checklists
    .filter((cl) => cl.companyId === cid)
    .flatMap((cl) => cl.items.map((item, idx) => ({ cl, item, idx })))
    .filter(({ item }) => item.proof?.status === "pendente");

export const trainingAvg = (s, collabIds, trainingId) => {
  const vals = collabIds.flatMap((id) => (trainingId ? [s.progress[id]?.[trainingId] ?? 0] : Object.values(s.progress[id] || {})));
  return vals.length ? Math.round(vals.reduce((a, b) => a + b, 0) / vals.length) : 0;
};
